import { render, staticRenderFns } from "./NcdTopContainer.vue?vue&type=template&id=f8ff745e&scoped=true"
import script from "./NcdTopContainer.vue?vue&type=script&lang=js"
export * from "./NcdTopContainer.vue?vue&type=script&lang=js"
import style0 from "./NcdTopContainer.vue?vue&type=style&index=0&id=f8ff745e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ff745e",
  null
  
)

export default component.exports